import Image from 'next/image';
import { Box } from '@mui/material';

import filledChilli from '@public/assets/png/filledChilli.png';

export const GetFilledChilli = () => {
  return (
    <Box
      sx={{
        display: 'inline-block',
        position: 'relative',
        height: '26px',
        width: '20px',
      }}
    >
      <Image
        src={filledChilli}
        alt="FilledChilli"
        objectFit="contain"
        layout="fill"
      />
    </Box>
  );
};
